import { useState, useEffect } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import { UserResponse } from '../../../../Api/User/models';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

export const NoteTaker = ({ userInfo }: { userInfo: UserResponse | null | undefined }) => {
    const [notes, setNotes] = useState('');
    const [isExpanded, setIsExpanded] = useState(true);

    // Clave única para el localStorage basada en el ID del usuario
    const storageKey = `user_notes_${userInfo?.id}`;
    const expandStateKey = `user_notes_expanded_${userInfo?.id}`;

    // Cargar notas y estado de expansión al iniciar
    useEffect(() => {
        const savedNotes = localStorage.getItem(storageKey);
        if (savedNotes) {
            setNotes(savedNotes);
        }

        const savedExpandState = localStorage.getItem(expandStateKey);
        if (savedExpandState !== null) {
            setIsExpanded(savedExpandState === 'true');
        }
    }, [storageKey, expandStateKey]);

    const handleAutoSave = (value: string) => {
        setNotes(value);
        localStorage.setItem(storageKey, value);
    }

    const toggleExpand = () => {
        const newExpandState = !isExpanded;
        setIsExpanded(newExpandState);
        localStorage.setItem(expandStateKey, newExpandState.toString());
    }

    return (
        <Card className='border-lowgray rounded-3 w-100'>
            <Card.Body>
                <div role='button' className='text-primary text-xs d-flex align-items-center justify-content-between' onClick={toggleExpand}>
                    <span>Mis Notas</span>
                    <Button
                        variant="link"
                        className="p-0 text-primary"
                        aria-label={isExpanded ? "Ocultar notas" : "Mostrar notas"}
                    >
                        {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                    </Button>
                </div>
                {isExpanded && (
                    <>
                        <Card.Body>
                            <Form.Control
                                as="textarea"
                                value={notes}
                                onChange={(e) => handleAutoSave(e.target.value)}
                                placeholder="Escribe tus notas aquí..."
                                className="bg-dark text-light border-secondary"
                                style={{
                                    minHeight: '200px',
                                    resize: 'vertical',
                                    fontSize: '0.9rem',
                                    lineHeight: '1.5'
                                }}
                            />
                        </Card.Body>
                        <Card.Footer className="bg-darker border-scondary">
                            <small className="text-secondary text-end d-flex justify-content-end text-xs">
                                * Tus notas se guardan unicamente en este dispositivo y son privadas para tu usuario.
                            </small>
                        </Card.Footer>
                    </>
                )}
            </Card.Body>
        </Card>
    );
};
